import styled from "styled-components";

const Wrapper = styled.div`
    width: 90%;
    margin: 0 auto;
    max-width: 1100px;
`

export default Wrapper;